<template>
    <div>
        <div @mouseleave="showEdit = false" @mousemove="showEdit = true">
            <el-link @click="editTag">{{ data }}</el-link>
        </div>
    </div>
</template>

<script>
export default {
    // name: "ParamsDescription",
    name: "ParamsEdit",
    props: ["data", "row"],
    data() {
        return {
            showEdit: false,
        }
    },
    methods: {
        editTag() {
            this.$emit("click");
        },
    }
}
</script>

<style lang="less" scoped>
.edit-btn {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 0 5px 0 5px;
    vertical-align: -3px;
    background: url("@{zhijiStaticImagePath}class-spr.png") -76px 0;

    &:hover {
        background-position: -76px -22px;
    }
}
</style>